export default "__VITE_ASSET__C9kXo8ER__"